import AdminDataTable from "../../core/DataTable/DataTable";

export function UsersList() {
    return <AdminDataTable collection="users" columns={[
        {
            name: "ID",
            field: "id",
            type: "text",
            edit: false,
        },
        {
            name: "Username",
            field: "username",
            type: "text",
        },
        {
            name: "Email",
            field: "email",
            type: "text",
            edit: false,
        },
        {
            name: "Role",
            field: "role",
            type: "object",
            has: [
                {
                    name: "Role",
                    field: "title",
                    type: "text"
                },
                {
                    name: "Rights",
                    field: "userRights",
                    type: "feature"
                },
            ]
        },
        {
            name: "Image",
            field: "imageUrl",
            type: "image"
        },
        {
            name: "Created At",
            field: "createdAt",
            type: "datetime",
            edit: false,
        },
        {
            name: "Updated At",
            field: "updatedAt",
            type: "datetime",
            edit: false,
        },

    ]} />;
}